import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const deleteCommunity = async (id: string): Promise<void> => {
  if (!id) return;

  try {
    await firestore.collection(DB_PATH.COMMUNITY).doc(id).delete();
  } catch (error) {
    console.error("Error deleting community", error);
  }
};

